import { Injectable } from '@angular/core';
import { Memoize } from '@lx/shared/utils-http';
import { ConfigurationApiService } from '@lx/shared/api/services';
import { getLocale } from '@lx/shared/i18n';
import { getCompanyHeader, getConfiguration } from '@lx/shared/tokens';
import { Configuration } from '@lx/shared/types';
import { companyMarketConfigUIApiDtoToConfiguration } from '@lx/shared/utils';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ConfigurationService {
  private static configuration: Configuration;

  private readonly locale = getLocale();
  private readonly companyHeader = getCompanyHeader();
  private readonly configuration = getConfiguration();

  constructor(private configurationApiService: ConfigurationApiService) {
    ConfigurationService.configuration = this.configuration;
  }

  static getValue(key: string): boolean | string {
    return this.configuration[key];
  }

  @Memoize((language) => language)
  get(language?: string): Observable<Configuration> {
    const locale = language || this.locale;
    return this.configurationApiService.getConfigurationV2(locale, this.companyHeader).pipe(map(companyMarketConfigUIApiDtoToConfiguration));
  }
}
